import React, { useEffect, useRef, useState } from "react";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { dataRef } from "../utils/Firebabse";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { UpdateCamera } from "./SetCamera";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/database";
import "firebase/compat/storage";
import { callingFunction } from "./InteractObject";
import './canva.css';
import { RoomEnvironment } from 'three/examples/jsm/environments/RoomEnvironment.js';
import group from "./Images/Group 1.svg";
import Form from "./Form";
import List from "./List";
import Header from "./Header";
import Footer from "./Footer";
import "./Customizer.css"
import TWEEN from "@tweenjs/tween.js";
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
import Caution from './caution.jsx'
//import RecordRTC from "recordrtc";
import { startRecording, stopRecording } from "./Recorder";
//import { CSS2DRenderer,CSS2DObject} from "three/examples/jsm/renderers/CSS2DRenderer.js";
import { GLTFExporter } from "three/examples/jsm/exporters/GLTFExporter";

import {handleToggleImage} from './Header'
import { ARButton } from 'three/examples/jsm/webxr/ARButton';
import VrButton from './VrButton'; 
import { VRButton } from 'three/examples/jsm/webxr/VRButton.js';
import { render } from "@testing-library/react";


// Global error handling
window.onerror = function(message, source, lineno, colno, error) {
  console.error('Global Error: ', { message, source, lineno, colno, error });
};

window.onunhandledrejection = function(event) {
  console.error('Unhandled Promise Rejection: ', event.reason);
};
  //#region  VARIABLES

  export let arviewerLink,scene = "";
  export let hard,cause="";
  let isMuted;

  let loadedInteractModels = [];
  const storage = firebase.storage();
  const storageRef = storage.ref();

  const Viewer = (props) => {
  const canvasRef = useRef();
  const arButtonContainerRef = useRef();
  let uid = "";
  let lessonId = "";
  let simulationData, camDatum;
  const [datum, setDatum] = useState([]);
  const [spawnedModels, setspawnedModels] = useState([]);
  const [interactModels, setinteractModels] = useState([]);
  const [description, setdescription] = useState();
  const [popUp, SetPopUp] = useState(false);
  const [form, SetForm] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingz, setIsLoadingz] = useState(true);
  const [mouseMoving, setMouseMoving] = useState(true);
  const [imageUrl, setImageUrl] = useState("");
  const [imageVisible, setImageVisible] = useState(true);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageClicked, setImageClicked] = useState(false);
  const [showImage, setShowImage] = useState(false);
  const [isScrollLocked, setIsScrollLocked] = useState(true);
  const [isRightClickLocked, setIsRightClickLocked] = useState(true);

  //caution
  const [isVisible, setIsVisible] = useState(true);
  const [isDragging, setIsDragging] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const [isVisiblezz, setIsVisiblezz] = useState(true);
  const [isImageVisible, setIsImageVisible] = useState(false);
  const [showFirstImage, setShowFirstImage] = useState(true);
  const [showSecondImage, setShowSecondImage] = useState(false);
  const [rendererr, setRendererr] = useState(null);
  const [cameraz, setCamerz] = useState(null);
  const [controlz, setControlz] = useState(null);
  const [spawnmodelz, setspawnmodelz] = useState(null);
  const [arEnabled, setArEnabled] = useState(false);
  const [scenez, setscenez] = useState(null);

  const [debugMessages, setDebugMessages] = useState(""); // State to store debug messages

  // Capture console messages
  useEffect(() => {
    const originalConsoleLog = console.log;
    const originalConsoleError = console.error;
    const originalConsoleWarn = console.warn;

    console.log = (...args) => {
      setDebugMessages((prev) => `${prev}\nLOG: ${args.join(" ")}`);
      originalConsoleLog(...args);
    };

    console.error = (...args) => {
      setDebugMessages((prev) => `${prev}\nERROR: ${args.join(" ")}`);
      originalConsoleError(...args);
    };

    console.warn = (...args) => {
      setDebugMessages((prev) => `${prev}\nWARN: ${args.join(" ")}`);
      originalConsoleWarn(...args);
    };

    return () => {
      console.log = originalConsoleLog;
      console.error = originalConsoleError;
      console.warn = originalConsoleWarn;
    };
  }, []);

  let meshDatum = {
    names: [],
    meshTranformArray: [],
  };

  let _tempInt = 0;
  let audio = new Audio;

  const loader = new GLTFLoader();
  const dracoLoader = new DRACOLoader();
  dracoLoader.setDecoderPath(
    "https://www.gstatic.com/draco/versioned/decoders/1.4.1/"
  );
  loader.setDRACOLoader(dracoLoader);


	let  renderer, controls, labelRenderer, container;
  let camera ;
  const cameraRef = useRef(null);
  const controlsRef = useRef(null);

  document.addEventListener("DOMContentLoaded", function() {
    try {
      var _container = document.getElementById("canvas");
      console.log('container: ', _container);
    } catch (error) {
      console.error('Error in DOMContentLoaded: ', error);
    }
  });
//webxr start 

  //#endregion


  useEffect(() => {
    try {
      const url = window.location.href;
      if (url.includes("?") && url.includes("=")) {
        const urlParts = url.split("?");
        const parameters = urlParts[1].split("=");
        uid = parameters[0];
        lessonId = parameters[1];
      }

      const userRef = dataRef.ref(`users/${uid}/Simulationlist/${lessonId}/`);
      userRef.on("value", (snapshot) => {
        try {
          simulationData = snapshot.val();
          console.log('snapshot.val(): ', snapshot.val());

          setDatum(simulationData);

          simulationData?.stepObjectsData?.forEach((el) => {
            const modelNameWithUnderscores = el.objectName.replace(/ /g, "_");
            const nameWithoutDots = modelNameWithUnderscores.replace(/\./g, "");
            if (!meshDatum.names.includes(nameWithoutDots)) {
              meshDatum.names.push(nameWithoutDots);
            }
            if (!meshDatum.meshTranformArray.includes(el.objectData)) {
              meshDatum.meshTranformArray.push(el.objectData);
            }
          });
          arviewerLink = simulationData?.arviewerLink;
          camDatum = simulationData?.cameraDatum;
          camera.userData.cameraDatum = camDatum;
        } catch (error) {
          console.error('Error processing snapshot: ', error);
        }
      });

      spawnModel();
    } catch (error) {
      console.error('Error in useEffect (initial setup): ', error);
    }
  }, []);

  useEffect(() => {
    if (canvasRef.current === null) return;

    scene = new THREE.Scene();
    setscenez(scene);
    scene.fog = new THREE.FogExp2(1.17);
    camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
    camera?.position.set(10, 10, 1);
    setCamerz(camera);
    camera.userData.cameraDatum = camDatum;
    camera.userData.updateCamera = UpdateCamera;
    cameraRef.current = camera;

    renderer = new THREE.WebGLRenderer(); 
    renderer.setPixelRatio( window.devicePixelRatio );
		renderer.setSize( window.innerWidth, window.innerHeight );
    renderer.setClearColor(0xffffff);
    renderer.xr.enabled = true;
   /* labelRenderer = new CSS2DRenderer();
    labelRenderer.setSize(window.innerWidth, window.innerHeight);
    labelRenderer.domElement.style.position = "absolute";
    labelRenderer.domElement.style.top = "0px";
    document.body.appendChild(labelRenderer.domElement);  */
    document.body.appendChild(renderer.domElement);
   

 new RGBELoader()
    .load('thatch_chapel_4k.hdr', function (texture){

        texture.mapping = THREE.EquirectangularReflectionMapping;    
        scene.background = texture;
        scene.enviroment = texture;
        //renderer();

    });


scene.background = null;
    window.addEventListener( 'resize', onWindowResize );
    controls = new OrbitControls(camera, renderer.domElement);
    controlsRef.current = controls
    //scene.background = new THREE.Color(0x8cc7de);
  
    scene.receiveShadow = true;
    const ambientLight = new THREE.AmbientLight(0xFFFFFF, 0.1);
    scene.add(ambientLight);



    const directionalLight = new THREE.DirectionalLight(0xFFFFFF, 0.1);
    directionalLight.position.set(0, 5, 0);
    directionalLight.castShadow = true;
    scene.add(directionalLight);
  
    const pmremGenerator = new THREE.PMREMGenerator(renderer);
    pmremGenerator.compileEquirectangularShader();
  
    const roomEnvironment = new RoomEnvironment();
   const environmentTexture = pmremGenerator.fromScene(roomEnvironment).texture;
  
   
    scene.environment = environmentTexture;
    
    animate();

    //document.body.appendChild(VRButton.createButton(renderer));



  setControlz(controls)
  setRendererr(renderer);





  // Cleanup function
  return () => {
    window.removeEventListener('resize', onWindowResize);
 
  };
//webxr
  // Create container div for ARButton

  const arButtonContainer = document.createElement('div');
  document.body.appendChild(arButtonContainer);
  const arButton = ARButton.createButton(renderer, {
    requiredFeatures: ['hit-test'],
    optionalFeatures: ['dom-overlay'],
    domOverlay: { root: arButtonContainer }
  });
  arButtonContainer.appendChild(arButton);

  // Cleanup function
  return () => {
    arButtonContainer.removeChild(arButton);
    document.body.removeChild(arButtonContainer);
  };

  //webxr end


  }, []);
  const checkXRSupport = async () => {
    let hitTestSource = null;
    let hitTestSourceRequested = false;
    
    if ('xr' in navigator) {
        const sizes = {
            width: window.innerWidth,
            height: window.innerHeight
        };

        let scene = new THREE.Scene();

        const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 1000);
        //camera.position.set(360,360,-360);
       // camera.lookAt(new THREE.Vector3(0, 0, 0));

        const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
        renderer.setSize(sizes.width, sizes.height);
        renderer.setPixelRatio(window.devicePixelRatio);
        
        document.body.appendChild(renderer.domElement);

        const session = await navigator.xr.requestSession('immersive-vr');
        renderer.xr.setSession(session);

        const referenceSpace = await session.requestReferenceSpace('local');
        hitTestSource = await session.requestHitTestSource({ space: referenceSpace });

        let reticle = new THREE.Mesh(
            new THREE.RingGeometry(0.15, 0.2, 32).rotateX(-Math.PI / 2),
            new THREE.MeshStandardMaterial({ color: 0xffffff, opacity: 0.5, transparent: true })
        );
        reticle.visible = false;
        reticle.name = 'reticle';
        scene.add(reticle);

        const controller = renderer.xr.getController(0);
        controller.addEventListener('select', onSelect);
        scene.add(controller);

        const gltfLoader = new GLTFLoader();

        async function onLoad(gltf) {
            if (gltf.scene) {
                scene.add(gltf.scene);
                console.log('GLTF model loaded successfully on WebXR:', gltf.scene);
            } else {
                console.error('Error: Loaded GLTF model has no scene.');
            }
        }

        async function spawnModels(urlList) {
            for (const url of urlList) {
                try {
                    const gltf = await gltfLoader.loadAsync(url);
                    onLoad(gltf);
                } catch (error) {
                    console.error('Error loading GLTF model:', error);
                }
            }
        }

        const uid = ''; // Set your user ID here
        const lessonId = ''; // Set your lesson ID here

        const urlList = await dataRef.ref(`users/${uid}/Simulationlist/${lessonId}/spawnedModelsLocation`).once('value').then(snapshot => snapshot.val());
        if (urlList && urlList.length > 0) {
            await spawnModels(urlList);
        }

        session.addEventListener('end', () => {
            hitTestSourceRequested = false;
            hitTestSource = null;
        });

        renderer.setAnimationLoop(render);

        function render(timestamp, frame) {
          if (!frame || !hitTestSource) {
              // Either frame or hitTestSource is not available, return early
              reticle.visible = false;
              return;
          }
      
          const hitTestResults = frame.getHitTestResults(hitTestSource);
          if (!hitTestResults || hitTestResults.length === 0) {
              // No hit test results available, hide reticle
              reticle.visible = false;
              return;
          }
      
          const hit = hitTestResults[0];
          reticle.visible = true;
          reticle.matrix.fromArray(hit.getPose(referenceSpace).transform.matrix);
      
          scene.children.forEach(object => {
              if (object.name === 'model') {
                  object.rotation.y += 0.01;
              }
          });
      
          renderer.render(scene, camera);
      }
      
      
      

        window.addEventListener('resize', () => {
            sizes.width = window.innerWidth;
            sizes.height = window.innerHeight;

            camera.aspect = sizes.width / sizes.height;
            camera.updateProjectionMatrix();

            renderer.setSize(sizes.width, sizes.height);
            renderer.setPixelRatio(window.devicePixelRatio);
        });
    } else {
        console.error('WebXR not supported');
    }
};


let loadedModels = [];
async function onSelect() {
 
    if (scene && loadedModels.length > 0) {
        let reticle = scene.getObjectByName('reticle');
        if (reticle) {
            let randomIndex = Math.floor((Math.random() * loadedModels.length));
            if (randomIndex >= 0 && randomIndex < loadedModels.length) {
                let model = loadedModels[randomIndex].clone();
                model.position.setFromMatrixPosition(reticle.matrix);
                model.scale.set(.1, .1, .1);
                model.name = "model";
                scene.add(model);
            } else {
                console.error("Error: Random index out of bounds.");
            }
        }
    }
}

  async function onLoad(gltf) {
    if (gltf.scene) {
        loadedModels.push(gltf.scene);
    } else {
        console.error("Error: Loaded GLTF model has no scene.");
    }
}
//   const setupWebXR = async () => {

//     const session = await navigator.xr.requestSession('immersive-ar', {
//       requiredFeatures: ['hit-test'],
//       optionalFeatures: ['dom-overlay']
//     });

//     const referenceSpace = await session.requestReferenceSpace('viewer');
//     const xrHitTestSource = await session.requestHitTestSource({ space: referenceSpace });
// // const loadedModels= spawnModel ;
//     // Create reticle
//     const reticle = new THREE.Mesh(
//       new THREE.RingGeometry(0.15, 0.2, 32).rotateX(-Math.PI / 2),
//       new THREE.MeshStandardMaterial({ color: 0xffffff * Math.random() })
//     );
//     reticle.visible = false;
//     reticle.matrixAutoUpdate = false;
//     scene.add(reticle);

//     session.addEventListener('end', () => {
//       reticle.visible = false;
//     });

//     session.addEventListener('select', () => {
//       if (reticle.visible) {
//         const randomIndex = Math.floor(Math.random() * spawnModel.length);
//         const model = spawnModel[randomIndex].clone();
//         model.position.setFromMatrixPosition(reticle.matrix);
//         model.scale.set(0.1, 0.1, 0.1);
//         model.name = 'model';
//         scene.add(model);
//       }
//     });

//     renderer.xr.setReferenceSpaceType('local');
//     renderer.xr.setSession(session);

//     renderer.xr.addEventListener('sessionend', () => {
//       renderer.setAnimationLoop(null);
//     });

//     renderer.xr.addEventListener('sessionstart', () => {
//       animate();
//     });

//     renderer.xr.addEventListener('select', () => {
//       if (!reticle.visible) return;
//       const randomIndex = Math.floor(Math.random() * spawnModel.length);
//       const model = spawnModel[randomIndex].clone();
//       model.position.setFromMatrixPosition(reticle.matrix);
//       model.scale.set(0.1, 0.1, 0.1);
//       model.name = 'model';
//       scene.add(model);
//     });

//     renderer.xr.addEventListener('selectstart', () => {
//       reticle.visible = true;
//     });

//     renderer.xr.addEventListener('selectend', () => {
//       reticle.visible = false;
//     });

//     renderer.xr.addEventListener('select', () => {
//       reticle.visible = true;
//     });

//     renderer.xr.addEventListener('selectend', () => {
//       reticle.visible = false;
//     });

//     renderer.xr.addEventListener('select', () => {
//       reticle.visible = true;
//     });

//     renderer.xr.addEventListener('selectend', () => {
//       reticle.visible = false;
//     });
//   };
const onWindowResize = () => {
  try {
    if (camera && renderer) {
      camera.aspect = window.innerWidth / window.innerHeight;
      camera.updateProjectionMatrix();
      renderer.setSize(window.innerWidth, window.innerHeight);
    }
  } catch (error) {
    console.error('Error in onWindowResize: ', error);
  }
};

const animate = () => {
  try {
    if (renderer && scene && camera) {
      renderer.setAnimationLoop(() => {
        controls.update();
        TWEEN.update();
        renderer.render(scene, camera);
      });
    }
  } catch (error) {
    console.error('Error in animate: ', error);
  }
};


  let called = false;

  const spawnModel = async () => {
    if (called) {
      return;
    }

    called = true;

    //#region  Load Environment
    dataRef
      .ref(`users/${uid}/Simulationlist/${lessonId}/spawnedEnevsLocation`)
      .once("value")
      .then((snapshot) => {
        const url = snapshot.val();

        url?.forEach((el) => {
          const enevURL = el;
          console.log("enevURL: ", enevURL);

          var fourthIndex = enevURL.indexOf(
            "%2",
            enevURL.indexOf(
              "%2",
              enevURL.indexOf("%2", enevURL.indexOf("%2") + 1) + 1
            ) + 1
          );
          var fileName = enevURL.substring(fourthIndex + 3);
          var enevName = storageRef.child(fileName.split("?")[0]).name;

          if (url) {

            loader.load(
              url,
              (gltf) => {
                const spawnedModel = gltf.scene;
                console.log('Model loaded in WebXR session:', spawnedModel);
                spawnedModel.name = enevName;

                simulationData?.spawnedEnevObjectDatum?.forEach((el) => {
                  if (el.spawnedEvenObjectName == spawnedModel.name) {
                    console.log("Model found!");

                    let {
                      x: posX,
                      y: posY,
                      z: posZ,
                    } = el.spawnedEvenObjectPosition;
                    let {
                      x: scaleX,
                      y: scaleY,
                      z: scaleZ,
                    } = el.spawnedEvenObjectScale;
                    let {
                      x: rotX,
                      y: rotY,
                      z: rotZ,
                      w: rotW,
                    } = el.spawnedEvenObjectRotation;

                    spawnedModel.position.set(-posX, posY, posZ);
                    spawnedModel.scale.set(scaleX, scaleY, scaleZ);
                    spawnedModel.rotation.setFromVector3(
                      el.spawnedEvenObjectRotation
                    );
                    //console.log('spawnedModel: ', spawnedModel.position,"---", el.spawnedEvenObjectPosition);
                    //console.log('spawnedModel: ', spawnedModel.scale,"---", el.spawnedEvenObjectScale);
                    //console.log('spawnedModel: ', spawnedModel.rotation,"---", el.spawnedEvenObjectRotation);
                  
                    setspawnmodelz(spawnedModel);
                 
                    setspawnedModels((prevModels) => {
                      return [...prevModels, spawnedModel];
                     
                    });
                  }
                });
            
                scene.add(spawnedModel);

              },
              (xhr) => {
                // Progress callback
                const progress = (xhr.loaded / xhr.total) * 100; // Calculate the loading progress
                console.log(progress + "% loaded");

                if (progress === 100) {
                  // Model fully loaded
                }
              },
              (error) => {
                console.error("Error loading GLTF model:", error);
              }
            );
            
          }
        });
      })
      .catch((error) => {
        //console.error("Error getting download URL:", error);
      });
    //#endregion

//#region Load User Uploaded Models
dataRef
  .ref(`users/${uid}/Simulationlist/${lessonId}/spawnedModelsLocation`)
  .once("value")
  .then((snapshot) => {
    const urlList = snapshot.val();
 
    if (urlList && urlList.length > 0) {
      // Define a recursive function to load models sequentially
      const loadModelsSequentially = (index) => {
        if (index < urlList.length) {
          const modelURL = urlList[index];
          //console.log("modelURL: ", modelURL);

          var fourthIndex = modelURL.indexOf(
            "%2",
            modelURL.indexOf(
              "%2",
              modelURL.indexOf("%2", modelURL.indexOf("%2") + 1) + 1
            ) + 1
          );
          var fileName = modelURL.substring(fourthIndex + 3);
          var modelName = storageRef.child(fileName.split("?")[0]).name;

          loader.load(
            modelURL,
            (gltf) => {
              const spawnedModel = gltf.scene;
              //console.log('spawnedModel: ', spawnedModel);
              console.log('Model loaded in WebXR session:', spawnedModel);
              const decodedString = decodeURIComponent(modelName);
          
              spawnedModel.name = decodedString;
              setspawnmodelz(spawnedModel);
              simulationData?.spawnedModelObjectDatum?.forEach((el) => {
                //console.log('el: ', el.spawnedModelObjectName, spawnedModel.name);
                if (el.spawnedModelObjectName === spawnedModel.name) {
                  //console.log("Model found!",spawnedModel);
                  setspawnmodelz(spawnedModel);
                  setspawnedModels((prevModels) => {
                    return [...prevModels, spawnedModel];
                    
                  });
                }
              });

              scene.add(spawnedModel);
              for (let i = 0; i < meshDatum.names.length; i++) {
                findObjectByName(
                  spawnedModel,
                  meshDatum.names[i],
                  meshDatum.meshTranformArray[i]
                );
              }
            
              // Load the next model recursively
              loadModelsSequentially(index + 1);
            
            },
            (xhr) => {
              // Progress callback
              const progress = (xhr.loaded / xhr.total) * 100; // Calculate the loading progress
            //  console.log(progress + "% loaded");

              if (progress === 100) {
                // Model fully loaded
              }
            },
            (error) => {
              console.error("Error loading GLTF model:", error);
            }
          );
        }
        else{
          setIsLoading(false);
        }
      };

      // Start loading the models sequentially
      loadModelsSequentially(0);
    }
  })
  .catch((error) => {
    console.error("Error getting download URL:", error);
  });
//#endregion

//#region Library Models

// dataRef
//   .ref(`users/${uid}/Simulationlist/${lessonId}/spawnedModelObjectDatum`)
//   .once("value")
//   .then((snapshot) => {
//     let spawnedModelsObjectDatum = snapshot.val();

//     if (!spawnedModelsObjectDatum) {
//       spawnedModelsObjectDatum = simulationData?.spawnedModelObjectDatum;

//       return;
//     }

//     // Define a recursive function to load models sequentially
//     const loadModelsSequentially = (index) => {
//       if (index < spawnedModelsObjectDatum.length) {
//         const el = spawnedModelsObjectDatum[index];
//         const modelName = el.spawnedModelObjectName;
//         //console.log("modelName: ", modelName);
//         const gltfUrl = `ExpressVR_Inbuid_Models/LibraryModels/${modelName}`;
       
//         let { x: posX, y: posY, z: posZ } = el.spawnedModelObjectPosition;
//         let { x: scaleX, y: scaleY, z: scaleZ } = el.spawnedModelObjectScale;
//         let {
//           x: rotX,
//           y: rotY,
//           z: rotZ,
//           w: rotW,
//         } = el.spawnedModelObjectRotation;

  
//         storage
//           .ref(gltfUrl)
//           .getDownloadURL()
//           .then((url) => {
//             loader.load(
//               url,
//               (gltf) => {
//                 const spawnedModel = gltf.scene;
//                 spawnedModel.name = modelName;
//                 setspawnmodelz(spawnedModel);
//              //   controls.target = spawnedModel.position;
//              console.log('Model loaded in WebXR session:', spawnedModel);
//                 setspawnedModels((prevModels) => {
//                   return [...prevModels, spawnedModel];
//                 });

//                 spawnedModel.position.set(-posX, posY, posZ);
//                 spawnedModel.scale.set(scaleX, scaleY, scaleZ);
//                 spawnedModel.rotation.set(rotX, rotY, rotZ, rotW);

//                 if (!scene.children.includes(spawnedModel)) {
//                   const existingModels = scene.children.filter(
//                     (child) => child.name === spawnedModel.name
//                   );
//                   existingModels.forEach((model) => scene.remove(model));
//                 }
//                 setspawnmodelz(spawnedModel);
//                 scene.add(spawnedModel);

//                 for (let i = 0; i < meshDatum.names.length; i++) {
//                   findObjectByName(
//                     spawnedModel,
//                     meshDatum.names[i],
//                     meshDatum.meshTranformArray[i]
//                   );
//                 }

//                 // Load the next set of models recursively
//                 loadModelsSequentially(index + 1);
//               },
//               (xhr) => {
//                 // Progress callback
//                 const progress = (xhr.loaded / xhr.total) * 100; // Calculate the loading progress
//                 //console.log(progress + "% loaded");

//                 if (progress === 100) {
//                 }
//               },
//               (error) => {
//                 console.error("Error loading GLTF model:", error);
//               }
//             );
//           })
//           .catch((error) => {
//             //console.error("Error getting download URL:", error);
//           });
        
//       }
//       else{
//         setIsLoading(false);
//       }
//     };

//     // Start loading the models sequentially
//     loadModelsSequentially(0);
//   });
//#endregion
  };

  let objectData = {};

  function findObjectByName(object, name, objectDatum) {
    if (objectDatum) {
      objectData = objectDatum;
    }

    if (object.name === name) {
      {
        setinteractModels((prevModels) => {
          return [...prevModels, object];
        });
        loadedInteractModels.push(object);
        object.userData.objectDatum = objectData;
        object.userData.interactObjectScript = callingFunction;
        object.userData.interactObjectScript('SetUpObject', object)
      }
    }

    for (let i = 0; i < object.children.length; i++) {
      const child = object.children[i];
      const found = findObjectByName(child, name);
      if (found) {
        return found;
      }
    }

    return null;
  }

  let isImage = false;
  const AnimateModel = async (_int, { stepDescription }) => {
    // console.clear();
    setdescription(stepDescription);
    if (audio !== undefined) {
      audio.pause();
      audio.currentTime = 0;
    }
    window.speechSynthesis.cancel();
    const stepCautionData = datum?.stepDatum[_int]?.stepCautionData;
    const stepHardwareData = datum?.stepDatum[_int]?.stepHardwareData;
    hard = stepHardwareData;
    cause = stepCautionData;
  
    if (stepCautionData) {
      await Promise.all(Object.entries(stepCautionData).map(async ([key, value]) => {
        console.log('stepCautionData: ', key, value);
      }));
    }
  
    if (stepHardwareData) {
      await Promise.all(Object.entries(stepHardwareData).map(async ([key, value]) => {
        console.log('stepHardwareData : ', key, value);
      }));
    }
  
    if (datum.audioLocation != undefined && datum?.audioLocation[_int - 1] != undefined) {
      audio = new Audio(datum?.audioLocation[_int - 1]);
      await audio.play();
    } else {
      if (!isMuted) {
        audio.pause();
        audio.currentTime = 0;
        const val = new SpeechSynthesisUtterance(stepDescription);
        window.speechSynthesis.speak(val);
      }
    }
  
    // Stop all TWEEN animations asynchronously
    await Promise.all(TWEEN.getAll().map(async tween => {
      tween.stop();
    }));
  
    await Promise.all(interactModels.map(async (element) => {
      element.userData.interactObjectScript('PlayAnim', element, _int - 1);
    }));
  
    if (datum?.stepDatum[_int]?.imageLocation != undefined) {
      const imageUrl = datum?.stepDatum[_int]?.imageLocation;
      setImageUrl(imageUrl);
      setImageLoaded(true);
    } else {
      setImageLoaded(false);
      setImageUrl("");
    }
  };
  



  const handleImageClick = () => {
    setIsLoadingz(false); // Set isLoading to false after clicking the image
    setImageClicked(true);
  };

  const raycaster = new THREE.Raycaster();
  const mouse = new THREE.Vector2();
  const loadedInteractModels = []; // Your array of mesh objects
  
  // Attach event listener to the canvas
 // document.addEventListener('mouseup', OnMouseup);
  
  // Mouse move event handler
  function OnMouseup(event) {
      // Calculate normalized mouse coordinates
      mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
      mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
  
      // Update the raycaster's position and direction
      raycaster.setFromCamera(mouse, camera);
  
      // Perform raycasting and handle the result
      const intersects = raycaster.intersectObjects(loadedInteractModels, true);
  
      if (intersects.length > 0) {
          // Mouse enters a mesh
          const enteredObject = intersects[0].object;
          console.log(`Entered ${enteredObject.name}`);
          loadedInteractModels.forEach(element => {
            if(element != enteredObject){
              element.userData.tempData.label.visible = false;
            }
          });
            enteredObject.userData.tempData.label.visible = true;
      } else {
          // Mouse exits all meshes
          console.log('Exited all objects');
          loadedInteractModels.forEach(element => {
            element.userData.tempData.label.visible = false;
          });
      }
  }
  
  // Function to trigger download of a specific GLTF model
/*function downloadModelAsGLTF(model, filename) {
  const exporter = new GLTFExporter();
  
  exporter.parse(model, (gltf) => {
    const json = JSON.stringify(gltf);
    const blob = new Blob([json], { type: 'application/json' });
    
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename || 'model.gltf';
    document.body.appendChild(link);
    link.click();
    
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  });
}

// Attach a keydown event listener to the document
document.addEventListener('keyup', (event) => {
  if (event.key === 'Enter') {
  //console.log('spawnedModels: ', spawnedModels);
  const modelNameToFind = "M_Drive.gltf";
  const modelToDownload = spawnedModels.find(model => model.name === modelNameToFind);

  // Check if the model was found and trigger the download
  if (modelToDownload) {
    console.log('modelToDownload: ', modelToDownload);
    downloadModelAsGLTF(modelToDownload, modelNameToFind);
  } else {
    console.log(`Model '${modelNameToFind}' not found.`);
  }
   // downloadModelAsGLTF(yourModel, 'M_Drive.gltf');
  }
});*/

   window.addEventListener('message', event => {
  // 👇️ check the origin of the data
  console.log("message received");
  if (event.origin === 'https://testkp.netlify.app') {
      // If this runs, the data was sent from your site
      // The data sent with postMessage() is accessed via
      // event.data
      console.log(event.data);
      AnimateModel(event.data.stepNumber,event.data.stepDescription)
  } else {
      // If this runs, the data was NOT sent from your site
      // Make sure to not use this data
      // You can remove the `else` statement
      console.log("wrong");
      return;
  }
   });



  //move
  useEffect(() => {
    let mouseTimer = null;
    let hideTimer = null;

    const handleMouseMove = () => {
      setShowImage(false);
      clearTimeout(mouseTimer);
      clearTimeout(hideTimer);
      mouseTimer = setTimeout(() => setShowImage(false), 3000); // Adjust the time here (in milliseconds)
      hideTimer = setTimeout(() => setShowImage(false), 6000); // Adjust the time here (in milliseconds)
    };

    const handleMouseLeave = () => {
      clearTimeout(mouseTimer);
      clearTimeout(hideTimer);
      setShowImage(false);
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseleave", handleMouseLeave);
      clearTimeout(mouseTimer);
      clearTimeout(hideTimer);
    };
  }, []);


  const handleConfirmClick = () => {
    if (showFirstImage) {
      setShowFirstImage(false);
      setShowSecondImage(true);
    } else if (showSecondImage) {
      setIsLoading(true);

      // Simulate loading, you can replace this with your actual data loading logic.
    // Adjust the timeout duration as needed
    }
  };
  const handleARButtonClick = () => {
    // Enable AR when AR button is clicked
    setArEnabled(true);
    spawnModel();
    alert("AR clicked")
    
  };
  return (
  
    <div>
      {imageClicked ? (
        <>
          {isLoading ? (
            <div
              onScroll={false}
              style={{
                display: "flex",
                justifyContent: "center",
                overflowX: "none",
                alignItems: "center",
                height: "100vh",
              }}
            >
              <img 
              style={{width: "9%",height:"9%"}}  onScroll={false}
                src="https://media-hosting.imagekit.io//32e1c74cc11c468b/load-37_256.gif?Expires=1836281126&Key-Pair-Id=K2ZIVPTIP2VGHC&Signature=ENGFqyNu88ok01DO~eSMoeSdutWmwrJuHKhV46vxSjcfRm09AaqbGGk7bJ8My~APShIjUI84LVwACMVSRCw7BCnUI9PJr5EN7wJwtadpHMJqk~lCOp8mH-l9ECEEvXe88NisuFIyhSm04HuUd07yVYRU-rohGSyFr3gE5YlGWYH4q3Tm38X5vqZ7tY5iJzVvJVow4OOzMecnJcjfVFekh92uOo-2nmVM5pJivXLUHX8ESgjcX5BzauSLSSvlRMIPvBBNEh~HM5Df7p0jHiF6YH-3aiTPNcdaqGKJ7k3inLqEN4Dk2bFcXBlJH~orpBhCoH2tNrbew--A38uOcP1fog__"
                className="preloader"
                alt=""
              />
            </div>
          ) : (
            
          
            <div
              className="Customizer"        
            >
              <div
                style={{
                  position: "relative",
               
                }}
              >
                {/* {showFirstImage && (
                  <img
                    src="first-image-url.jpg"
                    alt="First Image"
                    style={{ width: "100%", height: "auto" }}
                  />
                )}

                {showSecondImage && (
                  <img
                    src="second-image-url.jpg"
                    alt="Second Image"
                    style={{ width: "100%", height: "auto" }}
                  />
                )}

                {showFirstImage || showSecondImage ? (
                  <button onClick={handleConfirmClick}>I Confirm</button>
                ) : null} */}
        
                <Header description={description} setIsVisiblezz={setIsVisiblezz} isVisiblezz={isVisiblezz}  setIsImageVisible={setIsImageVisible} isImageVisible={isImageVisible} />

                <canvas id="canvas"  ref={canvasRef}></canvas>
       
        
                <VrButton rendererr={rendererr} cameraz={cameraz} controlz={controlz} spawnmodelz={spawnmodelz} spawnedModels={spawnedModels} scenez={scenez}    datum={datum}
              
                    AnimateModel={AnimateModel}/>
               {/* <button onClick={checkXRSupport}>Enable AR</button>*/}
                {/* <Effect spawnedModels={spawnedModels} Model={Model} /> */}

                {form && <Form SetForm={SetForm} form={form} />}

                <Footer
                  popUp={popUp}
                  datum={datum}
                  description={description}
                  SetPopUp={SetPopUp}
                  form={form}
                  SetForm={SetForm}
                />

{/* <Caution  isVisible={isVisible} isDragging={isDragging}  position={position}  setIsDragging={setIsDragging}  setIsVisible={setIsVisible} setPosition={setPosition} /> */}

                {/* <div style={{ position: 'absolute', top: 0, right: 0, zIndex: 1 }}>
      <img
        src="https://i.ibb.co/ssfyb7G/Group-23-1.png"
        style={{ width: '80px', height: '80px', maxHeight: '90%', maxWidth: '90%', visibility: showImage ? 'visible' : 'hidden' }}
        alt="Image"
      />
    </div> */}
          
                <div style={{ pointerEvents: imageClicked ? "auto" : "none" }}>
                  <List
                    popUp={popUp}
                    datum={datum}
                    SetPopUp={SetPopUp}
                    AnimateModel={AnimateModel}
                  />
                </div>
              
              </div>
            </div>
          )}
            
        </>
      ) : (
        <div className="click" onClick={handleImageClick}>
          <img src={group} alt="Image URL" />
        </div>
      )}
    </div>


  );
};

export default Viewer;

/*let mediaRecorder;
const chunks = [];

// Start screen recording
export function startRecording() {
  const canvas = _renderer.domElement;
  const screenStream = canvas.captureStream();

  const audioConstraints = {
    audio: true,
    video: false
  };

  navigator.mediaDevices.getUserMedia(audioConstraints)
    .then((audioStream) => {
      const mixedStream = new MediaStream();
      
      // Add tracks from screen capture and audio streams to the mixed stream
      screenStream.getTracks().forEach((track) => mixedStream.addTrack(track));
      audioStream.getTracks().forEach((track) => mixedStream.addTrack(track));

      mediaRecorder = new MediaRecorder(mixedStream);

      mediaRecorder.ondataavailable = (event) => {
        if (event.data && event.data.size > 0) {
          chunks.push(event.data);
        }
      };

      mediaRecorder.start();
      console.log('Recording started.');
    })
    .catch((error) => {
      console.error('Error accessing audio:', error);
    });
}

// Stop screen recording
export function stopRecording() {
  if (mediaRecorder && mediaRecorder.state !== 'inactive') {
    mediaRecorder.stop();

    mediaRecorder.onstop = () => {
      const videoBlob = new Blob(chunks, { type: 'video/webm' });
      chunks.length = 0;

      const downloadLink = document.createElement('a');
      downloadLink.href = URL.createObjectURL(videoBlob);
      downloadLink.download = 'screen_recording.webm';
      downloadLink.click();

      console.log('Recording stopped.');
    };
  }
}*/

export function setMute(_isMuted){
  isMuted = _isMuted;
}